@use "../../../theme/colors";

.container {
	display: flex;
	align-items: center;
	padding: 3px 7px;
	text-transform: uppercase;
	border-right: 2px solid;

	&:last-of-type {
		border-right: 0;
	}

	&[data-position="header"] {
		&:nth-child(3) {
			background-color: colors.$color-yellow;
		}
	}

	&[data-position="footer"] {

	}

	&[data-position="extra"] {

	}
}

.text {
	text-transform: uppercase;
	letter-spacing: 1.19px;
	cursor: pointer;
}

.link {
	text-decoration: none;
	overflow: hidden;
}

@media screen and (max-width: 480px) {

	.container {
		border-bottom: 2px solid colors.$color-blue;
		margin: 0;
		padding: 8px;

		&:first-of-type {
			border-top: 2px solid colors.$color-blue;
		}

		&:after {
			display: none;
		}

		&[data-position="header"] {

		}

		&[data-position="footer"] {
			justify-content: center;
		}

		&[data-position="extra"] {

			border: 0;
			padding: 8px 8px 0 8px;

			&:first-of-type {
				border-top: 0;
			}

			&:last-of-type {
				padding: 8px 8px 15px 8px;
			}
		}
	}

}
